import { LIST_APPS } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case LIST_APPS:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;